import { connect } from 'react-redux'
import ActionUnmarkConclusion from './action-unmark-conclusion'
import { getContribution } from '../../../../../stores/discussion/discussion.selectors'
import { distanceInWords } from 'date-fns'

const mapStateToProps = (state, { id }) => {
  const action = getContribution(state, id)
  return {
    id,
    name: action.originator.full_name,
    timestamp:
      action.action_object &&
      action.action_object.created_at &&
      distanceInWords(new Date(), new Date(action.action_object.created_at))
  }
}

export default connect(
  mapStateToProps,
  null
)(ActionUnmarkConclusion)
